import commonKK from 'i18n/locales/kk/common.json'
import footerKK from 'i18n/locales/kk/footer.json'
import kk from 'i18n/locales/kk/kk.json'
import landingKK from 'i18n/locales/kk/landing.json'
// import mainKK from 'i18n/locales/kk/main.json'
import commonRU from 'i18n/locales/ru/common.json'
import footerRU from 'i18n/locales/ru/footer.json'
import landingRU from 'i18n/locales/ru/landing.json'
// import mainRU from 'i18n/locales/ru/main.json'
import ru from 'i18n/locales/ru/ru.json'

export const ruTranslations = {
  common: commonRU,
  landing: landingRU,
  main: ru,
  footer: footerRU
}

export const kkTranslations = {
  common: commonKK,
  landing: landingKK,
  main: kk,
  footer: footerKK
}
